import { PropTypes } from 'prop-types'
import React from 'react'
import { Redirect, Route } from 'react-router-dom'

import { getRoomName } from 'helpers/room'

const PrivateRoute = props => {
    const roomName = getRoomName()
    const redirectUrl = roomName ? `/login/?next=${roomName}` : '/login'

    return props.authenticated ? (
        <Route exact {...props} component={props.component} />
    ) : (
        <Redirect to={redirectUrl} />
    )
}

PrivateRoute.propTypes = {
    path: PropTypes.string.isRequired,
    exact: PropTypes.bool.isRequired,
    component: PropTypes.any.isRequired,
}

PrivateRoute.defaultProps = {
    path: null,
    exact: false,
    component: null,
}

export default PrivateRoute
